<template>
  <el-dialog title="修改密码" width="30%"
             :visible.sync="dialogVisible"
             :close-on-click-modal="false">
    <el-form :model="formModel" :rules="formRules" ref="formRef" label-width="100px">
      <el-form-item label="原密码" prop="password">
        <el-input type="password" v-model="formModel.password" />
      </el-form-item>
      <el-form-item label="新密码" prop="newPassword">
        <el-input type="password" v-model="formModel.newPassword" />
      </el-form-item>
      <el-form-item label="确认密码" prop="newPassword2">
        <el-input type="password" v-model="formModel.newPassword2" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleSubmit('formRef')">修 改</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import { updatePassword } from '@/api/system/user'
  export default {
      props: {
          visible: {
              type: Boolean,
              default: false
          }
      },
      data() {
          const validateNewPassword2 = (rule, value, callback) => {
              this.$refs["formRef"].validateField("newPassword", errMsg => {
                  if (errMsg) {
                      callback(new Error(errMsg))
                      return
                  }
                  const { newPassword } = this.formModel
                  if (value !== newPassword) {
                      callback(new Error('两次密码不一致!'))
                  } else {
                      callback()
                  }
              })
          }
          return {
              dialogVisible: this.visible,
              formModel: {
                  password: '',
                  newPassword: '',
                  newPassword2: ''
              },
              formRules: {
                  password: [
                      { required: true, message: '请输入原密码', trigger: 'blur' }
                  ],
                  newPassword: [
                      { required: true, message: '请输入新密码', trigger: 'blur' },
                      { min: 6, max: 12, message: '长度在 6 到 12 个字符', trigger: 'blur' }
                  ],
                  newPassword2: [
                      { required: true, message: '请输入确认密码', trigger: 'blur' },
                      { validator: validateNewPassword2, trigger: 'blur' }
                  ]
              }
          }
      },
      watch: {
          visible(val, oldval) {
              if (val === oldval) {
                  return
              }
              this.dialogVisible = val
          },
          dialogVisible(val, oldval) {
              if (!val) {
                  this.$refs["formRef"].clearValidate()
              } else {
                  this.formModel = {
                      password: '',
                      newPassword: '',
                      newPassword2: ''
                  }
              }
              if (val === oldval) {
                  return
              }
              this.$emit('update:visible', val)
          }
      },
      methods: {
          handleSubmit(refName) {
              const formRef = this.$refs[refName]
              formRef.validate(valid => {
                  if (!valid) {
                      return
                  }
                  const { model } = formRef
                  delete model.newPassword2
                  updatePassword(model).then(() => {
                      this.$message.success("更新成功，下次登录生效")
                      this.dialogVisible = false
                  })
              })
          }
      }
  }
</script>
